module.exports = __webpack_public_path__ + "static/media/bg.31e7007b.png";